var _circle, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfiltered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.8602,
    cy: 47.8602,
    r: 47.8602,
    fill: "#F5F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3699 21.7848H46.875V12.1094H80.2948C80.3562 12.1094 80.4177 12.1094 80.4791 12.1094C85.7009 12.2326 89.9398 16.5465 89.9398 21.7848H78.8818",
    fill: "#D5DAE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_23782_493356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2157 12.1094C79.2498 12.2326 77.4068 13.0338 76.1167 14.3896C75.9939 14.5128 75.871 14.6361 75.7481 14.821C74.5809 16.1768 73.7208 17.9639 73.7208 19.8744V77.4339C73.7208 82.7955 69.4205 87.1094 64.0758 87.1094H17.1406V19.443C17.2635 17.4709 18.0007 15.6837 19.2908 14.3896C20.7038 12.9722 22.6082 12.1094 24.7584 12.1094H72.0007H80.97C81.0314 12.1094 81.0928 12.1094 81.2157 12.1094Z",
    fill: "url(#paint0_linear_23782_493356)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3825 25.2941H50.4371C49.9457 25.2941 49.5156 24.8627 49.5156 24.3697C49.5156 23.8767 49.9457 23.4453 50.4371 23.4453H64.3825C64.874 23.4453 65.304 23.8767 65.304 24.3697C65.304 24.8627 64.9354 25.2941 64.3825 25.2941Z",
    fill: "#989FB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8636 25.2941H25.6793C25.1878 25.2941 24.7578 24.8627 24.7578 24.3697C24.7578 23.8767 25.1878 23.4453 25.6793 23.4453H43.9251C44.4165 23.4453 44.8466 23.8767 44.8466 24.3697C44.8466 24.8627 44.4165 25.2941 43.8636 25.2941Z",
    fill: "#989FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5366 34.4191H37.4137C36.9222 34.4191 36.4922 33.9877 36.4922 33.4947C36.4922 33.0017 36.9222 32.5703 37.4137 32.5703H55.5366C56.028 32.5703 56.4581 33.0017 56.4581 33.4947C56.5195 33.9877 56.0895 34.4191 55.5366 34.4191Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5769 34.4191H25.6793C25.1878 34.4191 24.7578 33.9877 24.7578 33.4947C24.7578 33.0017 25.1878 32.5703 25.6793 32.5703H31.5769C32.0684 32.5703 32.4984 33.0017 32.4984 33.4947C32.4984 33.9877 32.0684 34.4191 31.5769 34.4191Z",
    fill: "#D5DAE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3808 43.5363H53.2613C52.7699 43.5363 52.3398 43.1049 52.3398 42.6119C52.3398 42.1189 52.7699 41.6875 53.2613 41.6875H64.3808C64.8723 41.6875 65.3023 42.1189 65.3023 42.6119C65.3023 43.1049 64.9337 43.5363 64.3808 43.5363Z",
    fill: "#D5DAE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9182 43.5363H25.6793C25.1878 43.5363 24.7578 43.1049 24.7578 42.6119C24.7578 42.1189 25.1878 41.6875 25.6793 41.6875H47.9182C48.4097 41.6875 48.8397 42.1189 48.8397 42.6119C48.8397 43.1049 48.4711 43.5363 47.9182 43.5363Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5374 52.6613H43.3121C42.8207 52.6613 42.3906 52.2299 42.3906 51.7369C42.3906 51.2439 42.8207 50.8125 43.3121 50.8125H55.5374C56.0288 50.8125 56.4589 51.2439 56.4589 51.7369C56.5203 52.2299 56.0903 52.6613 55.5374 52.6613Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.966 52.6613H25.6793C25.1878 52.6613 24.7578 52.2299 24.7578 51.7369C24.7578 51.2439 25.1878 50.8125 25.6793 50.8125H38.0274C38.5189 50.8125 38.9489 51.2439 38.9489 51.7369C38.9489 52.2299 38.5189 52.6613 37.966 52.6613Z",
    fill: "#D5DAE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3826 61.7785H55.8434C55.3519 61.7785 54.9219 61.3471 54.9219 60.8541C54.9219 60.3611 55.3519 59.9297 55.8434 59.9297H64.3826C64.8741 59.9297 65.3041 60.3611 65.3041 60.8541C65.3041 61.3471 64.9355 61.7785 64.3826 61.7785Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3136 61.7785H35.9996C35.5082 61.7785 35.0781 61.3471 35.0781 60.8541C35.0781 60.3611 35.5082 59.9297 35.9996 59.9297H50.3136C50.8051 59.9297 51.2351 60.3611 51.2351 60.8541C51.2351 61.3471 50.8051 61.7785 50.3136 61.7785Z",
    fill: "#D5DAE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6554 61.7785H25.6793C25.1878 61.7785 24.7578 61.3471 24.7578 60.8541C24.7578 60.3611 25.1878 59.9297 25.6793 59.9297H30.6554C31.1469 59.9297 31.5769 60.3611 31.5769 60.8541C31.5769 61.3471 31.1469 61.7785 30.6554 61.7785Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.536 70.9035H47.0582C46.5668 70.9035 46.1367 70.4721 46.1367 69.9791C46.1367 69.4861 46.5668 69.0547 47.0582 69.0547H55.536C56.0275 69.0547 56.4575 69.4861 56.4575 69.9791C56.519 70.4721 56.0889 70.9035 55.536 70.9035Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4677 70.9035H25.6793C25.1878 70.9035 24.7578 70.4721 24.7578 69.9791C24.7578 69.4861 25.1878 69.0547 25.6793 69.0547H41.4677C41.9592 69.0547 42.3892 69.4861 42.3892 69.9791C42.3892 70.4721 41.9592 70.9035 41.4677 70.9035Z",
    fill: "#D5DAE5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4334 79.4688H55.843C55.843 81.5641 56.7031 83.4745 58.0546 84.8303C59.4061 86.2477 61.3106 87.0489 63.3993 87.0489H7.55631C5.46758 87.0489 3.56314 86.1861 2.2116 84.8303C0.860068 83.4745 0 81.5641 0 79.4688H36.7372C36.7372 79.4688 43.5563 79.5304 43.4334 79.4688Z",
    fill: "#D5DAE5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7059 73.5678L88.9492 65.8173L90.7274 64.0391L98.4779 71.7957L96.7059 73.5678Z",
    fill: "#989FB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4023 76.2949L93.4545 70.3471C92.9579 69.8504 92.9579 69.041 93.4545 68.5444C93.9512 68.0477 94.7606 68.0477 95.2573 68.5444L101.205 74.4922C101.702 74.9888 101.702 75.7982 101.205 76.2949C100.708 76.7916 99.899 76.7916 99.4023 76.2949Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9811 76.673L91.3287 69.0206C91.1509 68.8428 91.1509 68.5546 91.3287 68.3706L93.2847 66.4146C93.4625 66.2368 93.7507 66.2368 93.9347 66.4146L101.587 74.067C101.765 74.2448 101.765 74.533 101.587 74.717L99.6311 76.673C99.4471 76.8508 99.1589 76.8508 98.9811 76.673Z",
    fill: "url(#paint1_linear_23782_493356)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1704 40.8438C72.052 40.8438 65.4727 47.4231 65.4727 55.5415C65.4727 63.6538 72.052 70.2393 80.1643 70.2393C88.2827 70.2393 94.8621 63.6599 94.8621 55.5415C94.8621 47.4231 88.2827 40.8438 80.1704 40.8438ZM80.1704 67.5168C73.6524 67.5168 68.373 62.1515 68.373 55.5354C68.373 48.9192 73.6524 43.5601 80.1704 43.5601C86.6885 43.5601 91.9679 48.9254 91.9679 55.5415C91.9679 62.1577 86.6823 67.5168 80.1704 67.5168Z",
    fill: "url(#paint2_linear_23782_493356)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_23782_493356",
    x: 8.14062,
    y: 7.10938,
    width: 82.0742,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23782_493356"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_23782_493356",
    result: "effect2_dropShadow_23782_493356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_23782_493356",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23782_493356",
    x1: 49.1573,
    y1: 10.3746,
    x2: 49.1573,
    y2: 87.9179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23782_493356",
    x1: 96.4587,
    y1: 66.6469,
    x2: 96.4587,
    y2: 72.5545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23782_493356",
    x1: 80.1697,
    y1: 41.8649,
    x2: 80.1697,
    y2: 58.3643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfiltered);
export default __webpack_public_path__ + "static/media/unfiltered.a579365a3b853ac6c5dfc549c575c3ca.svg";
export { ForwardRef as ReactComponent };